import { Grid } from "@mui/material";
import Helpers from "../../../commons/helpers";
import { ICodename, IPolicy, PolicyRequirement, RoleResourcePermission } from "../../../commons/interfaces";
import { RoleHelpers } from "../../../commons/roleHelpers";
import { Mode } from "../../../constants/enums";
import { IPolicyError } from "../../../hooks/policy/edit";
import useStrings from "../../../hooks/useStrings";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";
import Autocomplete from "../../Autocomplete";
import Box from "../../Box";
import FormField from "../../FormField";
import Typography from "../../Typography";

export const PolicyBasicInfo = ({
    data,
    mode,
    services,
    error,
    onChangeValue,
}: {
    data: IPolicy;
    error: IPolicyError;
    mode: Mode;
    services: ICodename[];
    onChangeValue: (key: keyof IPolicy) => (value: string | number | PolicyRequirement[] | RoleResourcePermission[]) => void;
}) => {
    const Strings = useStrings();

    const { userInfo } = useCommonComponentContext();
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <Box alignItems="center" sx={{ display: "flex", flexWrap: "wrap" }}>
                    <Typography variant="h5">{Strings.POLICY.BASIC_INFO}</Typography>
                </Box>
            </Grid>
            {!RoleHelpers.isOrganizationUser(userInfo?.userProfile) && (
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        data={services || []}
                        label={Strings.POLICY.SERVICE}
                        placeholder={Strings.POLICY.SELECT_SERVICE}
                        errorMessage={error?.serviceCode}
                        defaultValue={data?.serviceCode}
                        disabled={!Helpers.isNullOrEmpty(data?.id)}
                        onChange={onChangeValue("serviceCode")}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6}>
                <FormField
                    required
                    mode={mode}
                    maxLength={255}
                    label={Strings.POLICY.NAME}
                    defaultValue={data?.policyName}
                    errorMessage={error?.policyName}
                    placeholder={Strings.POLICY.INPUT_NAME}
                    onBlur={onChangeValue("policyName")}
                />
            </Grid>

            <Grid item xs={12}>
                <FormField
                    multiline
                    isFullRow
                    mode={mode}
                    maxLength={255}
                    label={Strings.POLICY.DESCRIPTION}
                    defaultValue={data?.description}
                    errorMessage={error?.description}
                    placeholder={Strings.POLICY.INPUT_DESCRIPTION}
                    onBlur={onChangeValue("description")}
                />
            </Grid>
        </Grid>
    );
};

export default PolicyBasicInfo;
